import enData from "./enData";

export default {
    en : enData,
}
